import { render } from "./ExcelViewer.vue?vue&type=template&id=c0a9e444&scoped=true&ts=true"
import script from "./ExcelViewer.vue?vue&type=script&lang=ts"
export * from "./ExcelViewer.vue?vue&type=script&lang=ts"

import "./ExcelViewer.vue?vue&type=style&index=0&id=c0a9e444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a9e444"]])

export default __exports__